import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60a953a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "export-img-dialog" }
const _hoisted_2 = { class: "thumbnails-view" }
const _hoisted_3 = { class: "configs" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "导出格式：", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("JPEG")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("PNG")
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "导出范围：", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("当前页")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("自定义")
const _hoisted_13 = {
  key: 0,
  class: "row"
}
const _hoisted_14 = ["data-range"]
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "图片质量：", -1))
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "忽略在线字体：", -1))
const _hoisted_19 = { class: "config-item" }
const _hoisted_20 = { class: "btns" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("导出图片")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("关闭")

import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import useExport from '@/hooks/useExport'

import ThumbnailSlide from '@/views/components/ThumbnailSlide/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportImage',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {



const { slides, currentSlide } = storeToRefs(useSlidesStore())

const imageThumbnailsRef = ref<HTMLElement>()
const rangeType = ref<'all' | 'current' | 'custom'>('all')
const range = ref<[number, number]>([1, slides.value.length])
const format = ref<'jpeg' | 'png'>('jpeg')
const quality = ref(1)
const ignoreWebfont = ref(true)

const renderSlides = computed(() => {
  if (rangeType.value === 'all') return slides.value
  if (rangeType.value === 'current') return [currentSlide.value]
  return slides.value.filter((item, index) => {
    const [min, max] = range.value
    return index >= min - 1 && index <= max - 1
  })
})

const { exportImage, exporting } = useExport()

const expImage = () => {
  if (!imageThumbnailsRef.value) return
  exportImage(imageThumbnailsRef.value, format.value, quality.value, ignoreWebfont.value)
}

return (_ctx: any,_cache: any) => {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FullscreenSpin = _resolveComponent("FullscreenSpin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "thumbnails",
        ref_key: "imageThumbnailsRef",
        ref: imageThumbnailsRef
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(renderSlides), (slide) => {
          return (_openBlock(), _createBlock(ThumbnailSlide, {
            class: "thumbnail",
            key: slide.id,
            slide: slide,
            size: 1600
          }, null, 8, ["slide"]))
        }), 128))
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_RadioGroup, {
          class: "config-item",
          value: format.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((format).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RadioButton, {
              style: {"width":"50%"},
              value: "jpeg"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_RadioButton, {
              style: {"width":"50%"},
              value: "png"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_RadioGroup, {
          class: "config-item",
          value: rangeType.value,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((rangeType).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RadioButton, {
              style: {"width":"33.33%"},
              value: "all"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_RadioButton, {
              style: {"width":"33.33%"},
              value: "current"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_RadioButton, {
              style: {"width":"33.33%"},
              value: "custom"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      (rangeType.value === 'custom')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", {
              class: "title",
              "data-range": `（${range.value[0]} ~ ${range.value[1]}）`
            }, "自定义范围：", 8, _hoisted_14),
            _createVNode(_component_Slider, {
              class: "config-item",
              range: "",
              min: 1,
              max: _unref(slides).length,
              step: 1,
              value: range.value,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((range).value = $event))
            }, null, 8, ["max", "value"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode(_component_Slider, {
          class: "config-item",
          min: 0,
          max: 1,
          step: 0.1,
          value: quality.value,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((quality).value = $event))
        }, null, 8, ["step", "value"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_Tooltip, {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "导出时默认忽略在线字体，若您在幻灯片中使用了在线字体，且希望导出后保留相关样式，可选择关闭【忽略在线字体】选项，但要注意这将会增加导出用时。"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Switch, {
                checked: ignoreWebfont.value,
                "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((ignoreWebfont).value = $event))
              }, null, 8, ["checked"])
            ]),
            _: 1
          }, 8, ["mouseEnterDelay"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_Button, {
        class: "btn export",
        type: "primary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (expImage()))
      }, {
        default: _withCtx(() => [
          _hoisted_21
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "btn close",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('close')))
      }, {
        default: _withCtx(() => [
          _hoisted_22
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_FullscreenSpin, {
      loading: _unref(exporting),
      tip: "正在导出..."
    }, null, 8, ["loading"])
  ]))
}
}

})